<template>
  <custom-dialog width="75%" :title="model.title" :visible="visible" v-on="$listeners" class="bind-device-dialog">
    <div class="dialog-body" style="padding-top: 0">
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('base_bindDeviceDialog.jshModemSNjqmc')" @fetch="onPageChange({ page: 1 })" style="float: right"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('base_bindDeviceDialog.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :props="{ label: 'productCode', value: 'productCode' }"
              :placeholder="$t('Common.com_please_select')"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('base_bindDeviceDialog.zu_zhi_ming_cheng')">
            <custom-select
              style="display: inline-block; width: 98px; margin-right: 2px"
              @clear="formSearch.orgName = ''"
              v-model="formSearch.orgType"
              code="bas_org_type"
              :props="{ label: 'name', value: 'value' }"
              :placeholder="$t('base_bindDeviceDialog.zu_zhi_lei_xing')"
              width="100%"
            ></custom-select>
            <el-input :disabled="!formSearch.orgType" v-model="formSearch.orgName" style="width:calc(100% - 100px)"></el-input>
          </el-form-item>
          <el-form-item :label="$t('base_bindDeviceDialog.xiang_mu_ming_cheng')">
            <el-input v-model="formSearch.locationName" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('base_bindDeviceDialog.xiang_mu_biao_qian')">
            <el-input v-model="formSearch.tagName" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('base_bindDeviceDialog.he_tong_bian_hao')">
            <el-input v-model="formSearch.contractNo" style="width:100%;"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <custom-table
        type="checkbox"
        :tableCode="model.data.tableCode || 'organ_device'"
        v-model="tableSelect"
        @column="setColumn"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="bindDevice">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  mixins: [dialogMixins, resetFormSearchMixins],
  data() {
    return {
      visible: true,
      tableList: [],
      totalRows: 0,
      tableSelect: [],

      formSearch: {
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 10,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        tagName: '',
        contractNo: ''
      }
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.formSearch.bizId = this.model.data.user && this.model.data.user.bizId ? this.model.data.user.bizId : this.model.data.organ.bizId;
      this.formSearch.bizType = this.model.data.user && this.model.data.user.bizId ? this.model.data.user.bizType : this.model.data.organ.bizType;
      this.formSearch.parentId = this.model.data.organ.orgId;
      this.getDeviceList();
    },
    // 获取设备列表
    getDeviceList: function () {
      this.$getJSON(apis.BizDevicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    clearFilter: function () {
      this.formSearch.productCode = '';
      this.formSearch.orgType = '';
      this.formSearch.orgName = '';
      this.formSearch.locationName = '';
      this.formSearch.tagName = '';
      this.formSearch.contractNo = '';
      this.onPageChange({ page: 1 });
    },
    // 关联设备
    bindDevice: function () {
      const deviceIds = this.tableSelect.map(t => t.deviceId);
      this.$postJSON(
        apis.DeviceBind,
        {
          bizOrgId: this.model.data.organ.orgId,
          bizId: this.model.data.user && this.model.data.user.bizId ? this.model.data.user.bizId : this.model.data.organ.bizId,
          bizType: this.model.data.user && this.model.data.user.bizId ? this.model.data.user.bizType : this.model.data.organ.bizType,
          parentId: this.model.data.user && this.model.data.user.bizId ? this.model.data.organ.orgId : this.model.data.organ.parentId,
          deviceIds: deviceIds
        },
        true
      ).then(() => {
        const msg = this.$t('Common.com_handle_success');
        this.$message({
          message: msg,
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss">
</style>
